import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'

function BasketStatisticsRow(props) {
    const { item, tableType } = props
    const {
        basket,
        item_index,
        item_number,
        event_meta,
        created,
        user_created,
    } = { ...item }
    return (
        <tr>
            <td>
                {!!basket && !!basket.number &&
                    <Link
                        to={`/baskets/${basket._id}`}
                        target='_blank'>
                        {basket.number || '-'}
                    </Link>
                }
            </td>
            <td>{item_number ? `#${item_number}` : '-'}</td>
            {tableType === 'tableAdd' &&
                <>
                    <td>{item_number && item_index ? `#${item_number}_${item_index}` : '-'}</td>
                    <td>{event_meta.type}</td>
                </>
            }
            <td>{!!event_meta && event_meta.ip_local ? event_meta.ip_local : '-'}</td>
            <td>{!!created ? moment(created).format('HH:mm DD/MM/YYYY') : '-'}</td>
            <td>{user_created || '-'}</td>
        </tr>
    )
}

export default BasketStatisticsRow